module.exports = __webpack_public_path__ + "img/carousel-img-4@3x.03035bf7.jpg";